var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7753 4.43612L11.1562 7.37552V5.10841C11.1562 4.48034 10.4613 4.09907 9.93155 4.43612L5.3125 7.37552V0.859375C5.3125 0.419268 4.95573 0.0625 4.51562 0.0625H0.796875C0.356768 0.0625 0 0.419268 0 0.859375V14.1406C0 14.5807 0.356768 14.9375 0.796875 14.9375H16.2031C16.6432 14.9375 17 14.5807 17 14.1406V5.10841C17 4.48031 16.305 4.09907 15.7753 4.43612ZM15.4062 13.3438H1.59375V1.65625H3.71875V8.82716C3.71875 9.45523 4.41372 9.8365 4.94345 9.49946L9.5625 6.56005V8.82716C9.5625 9.4552 10.2575 9.8365 10.7872 9.49946L15.4062 6.56005V13.3438Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.6a19d392.svg";
export { ForwardRef as ReactComponent };